/**
 * Какая вкладка настроек была открыта последней (стори 18.1).
 *
 * <p>Раньше окно всегда открывалось на «Оформлении», даже если человек только что правил профиль
 * и вернулся дописать: путь до нужной формы каждый раз начинался заново.
 *
 * <p>Память живёт в модуле, а не в хранилище, намеренно: это удобство одного сеанса, а не
 * настройка. Писать ради него в EncryptedStorage при каждом переключении чипа — плата, которой
 * задача не стоит.
 */

/**
 * Стори 18.6. Вкладок стало пять вместо трёх: «Аккаунт» была свалкой из четырёх форм подряд —
 * профиль, ник со ссылкой, пароль и системный блок Android, — и человек искал нужную кнопку
 * прокруткой. Теперь каждая вкладка — одна тема:
 *
 * <ul>
 *   <li>{@code profile} — имя, статус, о себе (кто вы для собеседника);
 *   <li>{@code avatar} — фото профиля;
 *   <li>{@code account} — логин и пароль (чем вы входите);
 *   <li>{@code privacy} — публичный ник, ссылка, видимость, метаданные снимков;
 *   <li>{@code app} — тема, язык, отдача и системные настройки устройства.
 * </ul>
 */
export type SettingsTab = 'profile' | 'avatar' | 'account' | 'privacy' | 'app';

const DEFAULT_TAB: SettingsTab = 'profile';

let lastTab: SettingsTab = DEFAULT_TAB;

export function lastSettingsTab(): SettingsTab {
  return lastTab;
}

export function rememberSettingsTab(tab: SettingsTab): void {
  lastTab = tab;
}

/** Только для тестов: модульная память переживает рендеры и другие тесты. */
export function resetSettingsTabMemory(): void {
  lastTab = DEFAULT_TAB;
}
